import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-022",
  "use": "icon-022-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-022\">\r\n<path d=\"M5.41658 3.3335L2.5 5.8335L5.41658 8.75016\" stroke=\"currentColor\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n<path d=\"M2.5 5.8335H12.0807C14.9487 5.8335 17.3842 8.17533 17.496 11.0418C17.6141 14.0708 15.1113 16.6668 12.0807 16.6668H4.99933\" stroke=\"currentColor\" stroke-width=\"1.25\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol